module.exports = __webpack_public_path__ + "img/icon_panels_01.c693d9f6.svg";